/**
 * date modify enum type.
 *
 * @export
 * @returns {Object}
 */
export var DATEOPERATETYPE = {
    HOUR: 'hour',
    MINUTE: 'minute',
    SECOND: 'second',
};
export var TIMETYPE = {
    h: '时',
    m: '分',
    s: '秒',
};
/**
 * Clone a date object.
 *
 * @export
 * @param  {DATEOPERATETYPE} d The date to clone
 * @return {Array} The cloned date
 */
export function getSelectOption(_a) {
    var _b = _a.type, type = _b === void 0 ? '' : _b, _c = _a.interval, interval = _c === void 0 ? 1 : _c, _d = _a.disableOptions, disableOptions = _d === void 0 ? [] : _d;
    var options = [];
    var maxOpts = 60;
    if (type === DATEOPERATETYPE.HOUR) {
        maxOpts = 24;
    }
    for (var i = 0; i < maxOpts; i += 1) {
        var disable = false;
        // @ts-ignore: Unreachable code error
        if (disableOptions.length > 0 && disableOptions.indexOf(i) > -1) {
            disable = true;
        }
        if (interval > 1) {
            if (i % interval === 0) {
                options.push({
                    // @ts-ignore: Unreachable code error
                    value: i,
                    // @ts-ignore: Unreachable code error
                    disable: disable,
                });
            }
        }
        else {
            options.push({
                // @ts-ignore: Unreachable code error
                value: i,
                // @ts-ignore: Unreachable code error
                disable: disable,
            });
        }
    }
    return options;
}
/**
 * 补齐数字位数
 * @return {string}
 */
export function getNumTwoBit(n) {
    n = Number(n);
    return (n > 9 ? '' : '0') + n;
}
export default {
    getSelectOption: getSelectOption,
    getNumTwoBit: getNumTwoBit,
};
